import { InjectionToken } from '@angular/core';

interface IEnvironment {
  name: string;
  production: boolean;
  services: {
    api: string;
  };
  sentryDsn?: string;
  googleAnalyticsId?: string;
  amplitudeId?: string;
  cookieHub?: string;
}

const SENTRY_DSN = 'https://b35bade662ec4b63acfcc1139039908f@o445185.ingest.sentry.io/5660970';

const PROD_API = '/backend/api/v1/affiliate-crm';

const IENVIRONMENT = new InjectionToken<IEnvironment>('environment');

export { IEnvironment, IENVIRONMENT, PROD_API, SENTRY_DSN };
